import { chemistryNetwork } from '../chemistry/ChemistryNetwork.js';

/**
 * Calculate team chemistry between two players using neural network
 * predictions and actual match data
 * @param {Object} player1 - First player object with stats
 * @param {Object} player2 - Second player object with stats
 * @param {Array} matches - Array of match objects to analyze for
 * actual chemistry
 * @returns {number} Chemistry score as a percentage (0-100)
 */
export const calculateTeamChemistry = (player1, player2, matches) => {
  const teamMatches = matches.filter(m => {
    const teammates =
      (m.winners.includes(player1.id) && m.winners.includes(player2.id)) ||
      (m.losers.includes(player1.id) && m.losers.includes(player2.id));
    return teammates;
  });

  if (teamMatches.length === 0) {
    return Math.round(chemistryNetwork.predict(player1, player2) * 100);
  }

  const wins = teamMatches.filter(m => m.winners.includes(player1.id)).length;
  const winRate = wins / teamMatches.length;
  const avgMargin =
    teamMatches.reduce((acc, m) => {
      const [s1, s2] = m.score.split('-').map(Number);
      return acc + (s1 - s2);
    }, 0) / teamMatches.length;

  const actualChemistry = winRate * 0.7 + ((avgMargin + 10) / 20) * 0.3;
  chemistryNetwork.train(player1, player2, actualChemistry);

  return Math.round(actualChemistry * 100);
};
